<template>
  <div class="text-center" v-if="info !== null">
    <h6>{{ info.name }}</h6>
    <h6><i class="fas fa-map-marker-alt"></i> {{ info.address }} - {{ info.city }}/{{ info.state }}</h6>
    <h6><i class="fas fa-phone"></i> {{ info.contact }}</h6>
    <hr>
    <a href="/termos-de-uso"><small>Termos de Uso</small></a>
    <br>
    <a href="/politicas-de-privacidade"><small>Política de Privacidade</small></a>
    <br>
    <a
        @click="modal.faq = true"
        rel="noopener noreferrer"
    ><small>Perguntas Frequentes</small></a>
    <v-dialog v-model="modal.faq" width="1200px">
      <Faq @onClose="closeModal" :isPublic="true"/>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import Faq from "@/views/Faq.vue";

export default {
  name: "FooterContact",
  components: {Faq},
  data: function () {
    return {
      info: null,
      modal: {
        faq: false,
      }
    }
  },
  mounted() {
    axios.get('api/common/info/print').then(res => {
      this.info = res.data;
      if (this.info !== null) {
        this.$emit('show', true);
      }
    })
  },
  methods: {
    closeModal: function () {
      this.modal.faq = false;
    }
  }
}
</script>

<style scoped>
.whatsapp {
  position: fixed;
  top: 88%;
  left: 0.5%;
  padding: 5px;
  z-index: 10000000;
}
</style>
